import BaseApi from '@/api/controller/base';

const API_URL = '3p-docutax/submission';

class DocutaxSubmissionsApi extends BaseApi {
  constructor() {
    super(API_URL);
  }

  search(filters) {
    return this.api.post('search', filters);
  }

  applyStatus(submissionId, status) {
    return this.api.put(`${submissionId}/apply-status/${status}`);
  }

  assignToMe(submissionId) {
    return this.api.put(`${submissionId}/assign-current-user`);
  }

  removeAssignment(submissionId) {
    return this.api.put(`${submissionId}/remove-assignment`);
  }

  transferOffice(submissionId, officeId) {
    return this.api.put(`${submissionId}/office/${officeId}/transfer`);
  }
}

const apiInstance = new DocutaxSubmissionsApi();
export { DocutaxSubmissionsApi, apiInstance };
export default apiInstance;
